var map = {
	"./add.svg": [
		1313,
		77
	],
	"./addBlack.svg": [
		1314,
		78
	],
	"./addWhite.svg": [
		1315,
		79
	],
	"./add_assignee.svg": [
		1316,
		80
	],
	"./add_to_dashboard.svg": [
		1317,
		81
	],
	"./add_workorder.svg": [
		1318,
		82
	],
	"./additional.svg": [
		1319,
		83
	],
	"./asset.svg": [
		1320,
		84
	],
	"./assistant-blue.svg": [
		1321,
		85
	],
	"./assistant-grey.svg": [
		1322,
		86
	],
	"./attach.svg": [
		1323,
		87
	],
	"./bill.svg": [
		1324,
		88
	],
	"./billHistory.svg": [
		1325,
		89
	],
	"./billHistorySelected.svg": [
		1326,
		90
	],
	"./billSelected.svg": [
		1327,
		91
	],
	"./billing.svg": [
		1328,
		92
	],
	"./billingSelected.svg": [
		1329,
		93
	],
	"./bot.svg": [
		1330,
		94
	],
	"./bouncedOrders.svg": [
		1331,
		95
	],
	"./bouncedOrdersSelected.svg": [
		1332,
		96
	],
	"./cameraBlue.svg": [
		1333,
		97
	],
	"./cameraRed.svg": [
		1334,
		98
	],
	"./cancel.svg": [
		1335,
		99
	],
	"./cancelOrder.svg": [
		1336,
		100
	],
	"./chat.svg": [
		1337,
		101
	],
	"./chatBlue.svg": [
		1338,
		102
	],
	"./chatRed.svg": [
		1339,
		103
	],
	"./checklist.svg": [
		1340,
		104
	],
	"./client-comments.svg": [
		1341,
		105
	],
	"./client-delete.svg": [
		1342,
		106
	],
	"./confirmOrder.svg": [
		1343,
		107
	],
	"./content.svg": [
		1344,
		108
	],
	"./createOrder.svg": [
		1345,
		109
	],
	"./createOrderSelected.svg": [
		1346,
		110
	],
	"./customer.svg": [
		1347,
		111
	],
	"./dashboard.svg": [
		1348,
		112
	],
	"./delete.svg": [
		1349,
		113
	],
	"./delivered.svg": [
		1350,
		114
	],
	"./diesel.svg": [
		1351,
		115
	],
	"./document.svg": [
		1352,
		116
	],
	"./duePayments.svg": [
		1353,
		117
	],
	"./duePaymentsSelected.svg": [
		1354,
		118
	],
	"./edit-pencil.svg": [
		1355,
		119
	],
	"./edit.svg": [
		1356,
		120
	],
	"./energy.svg": [
		1357,
		121
	],
	"./enter.svg": [
		1358,
		122
	],
	"./expand.svg": [
		1359,
		123
	],
	"./expired.svg": [
		1360,
		124
	],
	"./expiredSelected.svg": [
		1361,
		125
	],
	"./filter.svg": [
		1362,
		126
	],
	"./gallery.svg": [
		1363,
		127
	],
	"./generateInvoice.svg": [
		1364,
		128
	],
	"./graphs.svg": [
		1365,
		129
	],
	"./graphsSelected.svg": [
		1366,
		130
	],
	"./grey-right-arrow.svg": [
		1367,
		131
	],
	"./headcount.svg": [
		1368,
		132
	],
	"./hierarchy.svg": [
		1369,
		133
	],
	"./hierarchySelected.svg": [
		1370,
		134
	],
	"./hourglass-outline.svg": [
		1371,
		135
	],
	"./import.svg": [
		1372,
		136
	],
	"./in progress.svg": [
		1373,
		137
	],
	"./instructions.svg": [
		1374,
		138
	],
	"./inventory.svg": [
		1375,
		139
	],
	"./inventoryCheck.svg": [
		1376,
		140
	],
	"./inventoryCheckSelected.svg": [
		1377,
		141
	],
	"./invoice.svg": [
		1378,
		142
	],
	"./leftArr-blue.svg": [
		1379,
		143
	],
	"./leftArr-grey.svg": [
		1380,
		144
	],
	"./location.svg": [
		1381,
		145
	],
	"./locations.svg": [
		1382,
		146
	],
	"./mappingPeople.svg": [
		1383,
		147
	],
	"./mappingPeopleSelected.svg": [
		1384,
		148
	],
	"./message.svg": [
		1385,
		149
	],
	"./meter.svg": [
		1386,
		150
	],
	"./meters.svg": [
		1387,
		151
	],
	"./new-message.svg": [
		1388,
		152
	],
	"./noResultsSelected.svg": [
		1389,
		153
	],
	"./orderTracking.svg": [
		1390,
		154
	],
	"./orderTrackingSelected.svg": [
		1391,
		155
	],
	"./pendingOrders.svg": [
		1392,
		156
	],
	"./pendingOrdersSelected.svg": [
		1393,
		157
	],
	"./people.svg": [
		1394,
		158
	],
	"./pharmacyCatalog.svg": [
		1395,
		159
	],
	"./pharmacyCatalogSelected.svg": [
		1396,
		160
	],
	"./ppm.svg": [
		1397,
		161
	],
	"./purchase.svg": [
		1398,
		162
	],
	"./purchaseSelected.svg": [
		1399,
		163
	],
	"./purchase_order.svg": [
		1400,
		164
	],
	"./qr.svg": [
		1401,
		165
	],
	"./qrCode.svg": [
		1402,
		166
	],
	"./refresh.svg": [
		1403,
		167
	],
	"./reminder-bell.svg": [
		1404,
		168
	],
	"./remove.svg": [
		1405,
		169
	],
	"./report.svg": [
		1406,
		170
	],
	"./reports.svg": [
		1407,
		171
	],
	"./reportsSelected.svg": [
		1408,
		172
	],
	"./return.svg": [
		1409,
		173
	],
	"./returnSelected.svg": [
		1410,
		174
	],
	"./returns.svg": [
		1411,
		175
	],
	"./returnsSelected.svg": [
		1412,
		176
	],
	"./right-arrow.svg": [
		1413,
		177
	],
	"./rightArr-blue.svg": [
		1414,
		178
	],
	"./rightArr-grey.svg": [
		1415,
		179
	],
	"./rules.svg": [
		1416,
		180
	],
	"./rulesSelected.svg": [
		1417,
		181
	],
	"./search.svg": [
		1418,
		182
	],
	"./selectedBot.svg": [
		1419,
		183
	],
	"./selectedChat.svg": [
		1420,
		184
	],
	"./selectedContent.svg": [
		1421,
		185
	],
	"./selectedDashboard.svg": [
		1422,
		186
	],
	"./selectedFilter.svg": [
		1423,
		187
	],
	"./send_message.svg": [
		1424,
		188
	],
	"./set_date.svg": [
		1425,
		189
	],
	"./settings.svg": [
		1426,
		190
	],
	"./settingsSelected.svg": [
		1427,
		191
	],
	"./shrink.svg": [
		1428,
		192
	],
	"./star.svg": [
		1429,
		193
	],
	"./taxes.svg": [
		1430,
		194
	],
	"./taxesSelected.svg": [
		1431,
		195
	],
	"./tick.svg": [
		1432,
		196
	],
	"./tick_grey.svg": [
		1433,
		197
	],
	"./tickmark red.svg": [
		1434,
		198
	],
	"./tickmark white.svg": [
		1435,
		199
	],
	"./timer.svg": [
		1436,
		200
	],
	"./user.svg": [
		1437,
		201
	],
	"./vendor.svg": [
		1438,
		202
	],
	"./workorder.svg": [
		1439,
		203
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 873;
module.exports = webpackAsyncContext;